import styled from '@emotion/styled';
import { css } from '@emotion/react';

const stripeStyles = ({ theme }) => css`
    background-color: ${theme.color.white};
    position: relative;
    width: 100%;
    height: 3px;
    border-radius: 1px;
`;

export const Left = styled.div`
    top: 3px;
    ${stripeStyles};
    transform: rotate(45deg);
`;

export const Right = styled.div`
    ${stripeStyles};
    transform: rotate(-45deg);
`;

export const Container = styled.div`
    display: flex;
    flex: 1;
    width: 100%;
    height: 100%;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: ${(p) => p.theme.size.mediumLarge};
`;
